import axios from 'axios';
import config from './config';

console.log('========================================');
console.log('[API] Creating Axios Instance');
console.log('[API] Base URL:', config.apiUrl);
console.log('========================================');

// withCredentials: true sends the HttpOnly __ttauth cookie on every request.
// The cookie is set by the tt-auth proxy on the same origin as the API.
const api = axios.create({
  baseURL: config.apiUrl,
  withCredentials: true,
});

// Request interceptor — just logging (no token injection needed)
api.interceptors.request.use(
  (reqConfig) => {
    console.log(`[API] Request: ${reqConfig.method.toUpperCase()} ${reqConfig.url} (cookie auth)`);
    return reqConfig;
  },
  (error) => {
    console.error('[API] Request error:', error);
    return Promise.reject(error);
  }
);

// Response interceptor — log responses and handle non-auth errors.
// NOTE: 401 handling (redirect to login) is intentionally left to each
// component (ProtectedRoute) so the public landing page "/" can render
// without being hijacked by an auto-redirect when no cookie is present.
api.interceptors.response.use(
  (response) => {
    console.log(`[API] Response: ${response.status} ${response.config.url}`);
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      console.warn('[API] 401 Unauthorized — rejecting promise (caller handles redirect)');
    } else if (error.response?.status === 403) {
      console.warn('[API] 403 Forbidden - permission error (not auth error)');
      // Don't redirect — this is a permission/access issue, not an auth issue.
      // Let the calling component handle the error display.
    } else if (error.response?.status === 503) {
      console.warn('[API] 503 Service Unavailable - backend service error');
      // Don't redirect — let the calling component handle the error display.
    } else if (error.response) {
      console.error(`[API] Error: ${error.response.status} ${error.config.url}`, error.response.data);
    } else {
      console.error('[API] Network error:', error.message);
    }
    return Promise.reject(error);
  }
);

export default api;